export default __webpack_public_path__ + "static/media/la_capelle12.2eac515a.jpg";